module.exports = "<div class=gmw-modal> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=::captchaModalCtrl.header> </h4> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <holding-captcha class=gmw-modal__captcha ng-model=captchaModalCtrl.model.captcha required> </holding-captcha> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/controllers/captcha-modal/captcha-modal.html
// module id = 327
// module chunks = 0